import React from "react";
import styled from "styled-components";
import i18n from "live/services/i18n";

interface Props {
  onChange: Function;
  value: string;
}

export default function SearchBar({ onChange, value }: Props) {
  return (
    <Container>
      <i className="fa fa-search"></i>
      <input
        type="text"
        placeholder={i18n("Search a file")}
        title="Type in a name"
        onChange={(e) => onChange(e.target.value)}
        value={value}
        className="input-field"
      />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  /* margin-bottom: 10px; */

  i {
    position: absolute;
    padding: 10px;
    min-width: 40px;
    color: #868695;
  }

  input {
    width: 100%;
    padding: 10px 10px 10px 25px;
    text-align: left;
  }
`;
